module.exports = __webpack_public_path__ + "img/arrow-left.672f1903.svg";